import angular from 'angular';

/* eslint-disable */
export default function editCustomTestingProceduresDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.newCustomTestProcedure = angular.copy(vm.procedures);

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleFormSubmit = _handleFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editCustomTestingProceduresDialog);
  }

  function _handleFormSubmit() {
    loaderService.showViewLoader = true;

    vm.procedures.assessmentId = vm.assessmentId;
    vm.newCustomTestProcedure.assessmentId = vm.assessmentId;
    bcpDataService.saveCustomTestProcedures(vm.newCustomTestProcedure).then(() => {
      alerts.success('The custom testing procedures have been saved successfully.');

      $rootScope.$broadcast('refreshBCPAssessments');
      if (vm.saveType === 'saveAndClose') {
        _handleCloseDialog();
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

editCustomTestingProceduresDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
